export function waitForMessage(opts) {
  const timeoutMs = (opts && opts.timeoutMs) || 10000;

  return new Promise((resolve, reject) => {
    let settled = false;

    function checkOrigin(origin) {
      if (!opts || !opts.origin) return true;
      if (typeof opts.origin === 'function') return opts.origin(origin);
      return origin === opts.origin;
    }

    function cleanup() {
      window.removeEventListener('message', onMessage);
      if (opts && opts.signal) opts.signal.removeEventListener('abort', onAbort);
      clearTimeout(timer);
    }

    function onMessage(ev) {
      if (settled) return;
      if (!checkOrigin(ev.origin)) return;

      // opts.match should return truthy (payload) to accept, or false to ignore
      const result = opts && opts.match ? opts.match(ev) : ev.data;
      if (result !== false) {
        settled = true;
        cleanup();
        resolve(result);
      }
    }

    function onAbort() {
      if (settled) return;
      settled = true;
      cleanup();
      reject(new DOMException('Aborted', 'AbortError'));
    }

    const timer = setTimeout(() => {
      if (settled) return;
      settled = true;
      cleanup();
      reject(new Error('Timed out waiting for postMessage reply'));
    }, timeoutMs);

    window.addEventListener('message', onMessage);
    if (opts && opts.signal)
      opts.signal.addEventListener('abort', onAbort, { once: true })
  });
}
